import { render } from "./ComparePlans.vue?vue&type=template&id=670df7ff&scoped=true"
import script from "./ComparePlans.vue?vue&type=script&lang=js"
export * from "./ComparePlans.vue?vue&type=script&lang=js"

import "./ComparePlans.vue?vue&type=style&index=0&id=670df7ff&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670df7ff"]])

export default __exports__